export const APP_METADATA = {
  applicationName: 'ClaimsMicroUI',
  applicationVersion: '1.0.0'
};